import React, { useEffect, useRef, useState } from "react";
import "./table.css";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { orderHistoryList } from "../../redux/actions/orderActions";
import OrderHistoryTableData from "./orderHistoryTableData";
import LoadingSpinnerTable from "../utilites/loader";
import searcher from "../../assets/searchInput.svg";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../Pagination/number-pagination";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    maxWidth: "50rem",
    height: "28rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const OrderHistoryTable = ({ maxWidth = "100%", location }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const [page, setPage] = useState(page_no ?? 1);
  const [loading, setLoading] = useState(false);
  const [orderHistoryListData, setOrderHitoryListData] = useState({});
  const tableRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    if (location.pathname == "/orders-hostory") {
      dispatch(orderHistoryList({ page, search }, onSuccess, onError));
    }
  }, [location, search, page]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const onSuccess = (data) => {
    setLoading(false);
    setOrderHitoryListData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div
          className="search-container d-flex justify-content-between align-items-center position-sticky top-0 bg-white"
          style={{ zIndex: "10" }}
        >
          <div className="search-box d-flex align-items-center p-1 ms-2 mb-2">
            <img className="styled-SVG" src={searcher} alt="Search" />
            <input
              value={search}
              className="search-input text-dark fw_400 px-2"
              type="text"
              placeholder="Search Order ID, etc. "
              onChange={(e) =>
                navigate(
                  `/orders-hostory?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                )
              }
            />
          </div>
        </div>
        <TableContainer ref={tableRef} maxWidth={maxWidth}>
          <table className="main-table fs_10 text-nowrap w-100">
            <thead>
              <tr className="table-rows">
                <th className="main-table-heads" width={"2%"}>
                  #
                </th>
                <th className="main-table-heads" width={"10%"}>
                  Order ID
                </th>
                <th className="main-table-heads text-nowrap" width={"12%"}>
                  Order Date and Time
                </th>
                <th className="main-table-heads text-nowrap" width={"12%"}>
                  Invoice ID
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Invoicing Date & Time
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Division
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Doctor Name
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Pharmacy Name
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Order Status
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Reason for rejection
                </th>
                <th className="main-table-heads text-nowrap" width={"10%"}>
                  Actions
                </th>
              </tr>
            </thead>

            <tbody style={{ position: "relative" }}>
              {loading ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  {orderHistoryListData?.orders?.length > 0 ? (
                    orderHistoryListData?.orders?.map((ele, index) => (
                      <OrderHistoryTableData
                        data={ele}
                        index={index}
                        key={ele.id}
                        currentPage={
                          orderHistoryListData?.pagination?.currentPage
                        }
                      />
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        className="text-center no-data-container fs_16"
                      >
                        <span>~ No Data Found ~</span>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </TableContainer>
      </div>
      {orderHistoryListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={orderHistoryListData?.pagination?.currentPage}
          totalPages={orderHistoryListData?.pagination?.totalPages}
          path={`/orders-hostory`}
          filters={`${queryString}`}
        />
      )}
    </>
  );
};

export default OrderHistoryTable;
